//#region src/reward_type.ts
var RewardType = /* @__PURE__ */ function(RewardType) {
	RewardType[RewardType["Unknown"] = 0] = "Unknown";
	RewardType[RewardType["Percent"] = 1] = "Percent";
	RewardType[RewardType["Fixed"] = 2] = "Fixed";
	RewardType[RewardType["Wallet"] = 3] = "Wallet";
	RewardType[RewardType["WalletAndPayment"] = 4] = "WalletAndPayment";
	RewardType[RewardType["Payment"] = 5] = "Payment";
	RewardType[RewardType["FreeItem"] = 6] = "FreeItem";
	RewardType[RewardType["PaymentPlusReward"] = 7] = "PaymentPlusReward";
	RewardType[RewardType["Redeemable"] = 8] = "Redeemable";
	RewardType[RewardType["MealExchange"] = 9] = "MealExchange";
	RewardType[RewardType["WalletAndPaymentTaxExempt"] = 10] = "WalletAndPaymentTaxExempt";
	return RewardType;
}(RewardType || {});
//#endregion
export { RewardType };

//# sourceMappingURL=reward_type.js.map